import { PaginatedQueryPageInfoFragment } from 'generated/resources/graphql'

export const DEFAULT_PAGINATED_CONNECTION: {
  pageInfo: PaginatedQueryPageInfoFragment
  edges: {
    cursor: string
    node: unknown
  }[]
} = {
  pageInfo: {
    hasNextPage: false,
  },
  edges: [],
}
